import { takeLatest, call, put } from 'redux-saga/effects';
import api from '../../api/index';
import {
  GET_NOTIFICATION, SET_NOTIFICATION, NOTIFICATION_REQUEST_FAILED, SENDING_NOTIFICATION_REQUEST,
} from '../../types/Types';

/**
 * Call the api and dispatch data to the reducer
 * @param { Object } action Contained object data to be send to API call
 */
export function* getNotifications(action) {
  const { data } = action;

  try {
    yield put({
      type: SENDING_NOTIFICATION_REQUEST,
      nData: '',
      isNSending: true,
      isNSuccess: false,
      nError: false,
    });
    const response = yield call(api.notification, data);
    // console.log(response);
    if (response && response.data) {
      yield put({
        type: SET_NOTIFICATION,
        nData: JSON.parse(response.data.Body.toString()),
        isNSending: false,
        nError: false,
        isNSuccess: true,
      });
    } else {
      yield put({
        type: NOTIFICATION_REQUEST_FAILED,
        nData: null,
        isNSending: false,
        nError: true,
        isNSuccess: false,
        nMsg: response.errorMsg,
      });
    }
  } catch (e) {
    yield put({
      type: NOTIFICATION_REQUEST_FAILED,
      nMsg: e.message,
      isNSending: false,
      nError: true,
      isNSuccess: false,
      nData: null,
    });
  }
}

/**
 * map the dispatched action to the above function
 */
export default function* watchGetNotifications() {
  yield takeLatest(GET_NOTIFICATION, getNotifications);
}
